import { z } from 'zod'

export const adverseMediaListSchema = z.object({
  entityType: z.string().optional(),
  page: z.number().int().positive().default(1),
  size: z.number().int().positive().default(20),
  riskLevel: z.string().optional(),
  searchCase: z.string().optional()
})

export type AdverseMediaListRequest = z.infer<typeof adverseMediaListSchema>
